const YesNoNode = require('../YesNoNode');
const Q_faux_selves = require('./Q_faux_selves');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');

const Q_poisoner = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.YES] = new Q_faux_selves(actor, battleState);

  if (BattleCalc.getEquippedAbility(actor, 'poison_weapon')) {
    node.branches[node.NO] = new UseAbility({
      actor,
      abilityHandle: 'poison_weapon',
      staticTarget: actor,
      altNode: node.branches[node.YES],
    });
  } else {
    node.branches[node.NO] = node.branches[node.YES];
  }

  node.yesNoEvalFunction = function () {
    return BattleCalc.getCondition(actor, 'poisoner');
  };

  return node;
};
module.exports = Q_poisoner;
